module.exports = __webpack_public_path__ + "static/media/bell_light.84c36b25.svg";